import { IsOptional, IsNumber, Min } from 'class-validator';

export class EcommerceDeactivationIntegrationDto {
	@IsOptional()
	@IsNumber()
	@Min(1)
	public batchSize?: number;

	@IsOptional()
	@IsNumber()
	@Min(1)
	public daysUntilInactive?: number;
}